import { render, staticRenderFns } from "./HeaderSingle.vue?vue&type=template&id=a48dbf88&"
import script from "./HeaderSingle.vue?vue&type=script&lang=js&"
export * from "./HeaderSingle.vue?vue&type=script&lang=js&"
import style0 from "./HeaderSingle.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports